module.exports = __webpack_public_path__ + "static/media/BariolRegular-Italic.4e54ca6c.woff";